// The "I am a native client" signal for the F3 bearer-auth contract.
//
// The backend (backend/routes/auth.py) distinguishes web from native by ONE
// thing: a body field `client: "native"` on login/signup/verify/guest/refresh/
// logout. When present, the server returns tokens in the response BODY and sets
// NO cookies; when absent, it behaves exactly as pre-F3 (httpOnly cookies). The
// signal is a body field (not a header) on purpose — the Emergent proxy has a
// history of stripping headers, but a JSON body field always survives.
//
// ONE constant, ONE helper — never write the literal "native" anywhere else.
//
// withNativeSignal() is called UNCONDITIONALLY at every auth POST site. In the web
// build IS_APP_BUILD is false, so it returns the body untouched (identity) and web
// request bodies are unchanged; in the app build it merges the signal in. (Per
// F4.2a §6.A, IS_APP_BUILD is a runtime flag from buildTarget, so the inert branch
// ships in both bundles but is only taken where the flag matches.)

import { IS_APP_BUILD } from './buildTarget';

export const NATIVE_CLIENT_SIGNAL = 'native';
const NATIVE_CLIENT_FIELD = 'client';

// Web build: returns `body` unchanged (identity — undefined stays undefined, so
// `api.post(url, withNativeSignal())` is identical to `api.post(url)`).
// App build: returns a shallow copy with the native client signal added.
export function withNativeSignal(body) {
  if (!IS_APP_BUILD) return body;
  return { ...(body || {}), [NATIVE_CLIENT_FIELD]: NATIVE_CLIENT_SIGNAL };
}
